// @flow

// Log all track register actions to console when the specific dev log flag is set
export default function devLog(action: string, auxData: any) {
  /* eslint-disable no-console */
  if (typeof window !== 'undefined' && window.PINTEREST_DEV_LOG) {
    const regex = window.PINTEREST_DEV_REGEX || '';
    if (!regex || (action || '').match(regex)) {
      if (typeof auxData === 'object' && Object.keys(auxData).length) {
        console.log(action + ': %O', auxData);
      } else {
        console.log(action);
      }
    }
  }
  /* eslint-enable no-console */
}
